import React from 'react';
import { ArcStack } from '@src/core/ui';
import { OrdersWrapperView, ToggleCollapseView } from '@src/features/order/pages/orders-page/components';
import { useNavigate } from 'react-router-dom';
import { InFlightSectionProps } from './types';
import { OrderStatusEnum } from '@src/features/order/entities';
import { ORDER_COLUMN_CELL_SX } from '@src/features/order/pages/orders-page/constants';
import ArcInFlightCard from '@src/features/order/pages/orders-page/components/arc-in-flight-card';
import { routesConfig } from '@src/core/routes';
import { OrderMissionEntity } from '@src/core/features';
import { setSelectedDrone } from '@src/features/drone/redux';
import { useDispatch } from 'react-redux';
import { setMapLocation } from '@src/core/controllers';

const InFlightSection: React.FC<InFlightSectionProps> = (props) => {
  const { orders, selected, count } = props;
  const navigate = useNavigate();
  const inFlightCount = count;
  const dispatch = useDispatch();
  const onInFlightSelect = (order: OrderMissionEntity) => {  
    const firstOrderId = order?.orders?.[0]?.id;
    if (order?.orders?.length > 0) {
      dispatch(setSelectedDrone({...order.drone, currentOrderId: firstOrderId}));
    } else {
      dispatch(setSelectedDrone(order.drone));
    }
    const lat = Number(order.drone.latitude);
    const lng = Number(order.drone.longitude);
    if (Number.isFinite(lat) && Number.isFinite(lng)) {
      dispatch(
        setMapLocation({
          latitude: lat,
          longitude: lng,
        })
      );
    }
    const params = new URLSearchParams({ droneSerial: order.drone.serialNumber });
    if (firstOrderId != null) {
      params.set('orderId', String(firstOrderId));
    }
    navigate(`${routesConfig.drones}?${params.toString()}`);
  };
  
  return (
    <ArcStack direction='column' sx={ORDER_COLUMN_CELL_SX}>
      <ToggleCollapseView 
        count={inFlightCount} 
        status={OrderStatusEnum.IN_FLIGHT}>
        <OrdersWrapperView>
          {orders.map((order, index) => (
            <ArcInFlightCard
              key={order.missionId}
              order={order}
              isSelected={order.missionId === selected?.missionId}
              onClick={() => onInFlightSelect(order as unknown as OrderMissionEntity)}
              index={index}
              drone={order.drone}
              sx={{ width: '100%', minHeight:'140px' }}
            />))}
        </OrdersWrapperView>
      </ToggleCollapseView>
    </ArcStack>
  );
};

export default InFlightSection;